<template>
  <div class="dm-resultoverlay">
    <slot
      name="resultOverlay"
      :clearActiveDealer="clearActiveDealer"
      :getWebsite="getWebsite"
      :activeDealer="activeDealer"
      :translations="translations"
      :getCategoryCodeName="getCategoryCodeName"
      :getCategoryDisplayName="getCategoryDisplayName"
    >
      <div class="dm-resultoverlay__button" @click="clearActiveDealer()">
        <i class="far fa-angle-left"></i><span>{{ translations.Back }}</span>
      </div>
      <div class="dm-resultoverlay__body">
        <div
          class="dm-resultoverlay__label"
          v-if="getCategoryCodeName(activeDealer) !== ''"
        >
          <span
            :class="
              'badge badge-secondary badge-' + getCategoryCodeName(activeDealer)
            "
            >{{ getCategoryDisplayName(activeDealer) }}</span
          >
        </div>
        <div class="dm-resultoverlay__title">
          {{ activeDealer.Name }}
        </div>
        <div class="dm-resultoverlay__info">
          <div>{{ activeDealer.Address }}</div>
          <div>{{ activeDealer.Postalcode }} {{ activeDealer.City }}</div>
          <div>{{ activeDealer.Country }}</div>
        </div>
        <a
          :href="'tel:' + activeDealer.Phone"
          class="dm-resultoverlay__phone"
          v-if="activeDealer.Phone !== ''"
        >
          <i class="far fa-phone"></i>
          <span>{{ activeDealer.Phone }}</span>
          <i class="far fa-angle-right"></i>
        </a>
        <a
          :href="'mailto:' + activeDealer.EmailAddress"
          target="_blank"
          class="dm-resultoverlay__email"
          v-if="activeDealer.EmailAddress && activeDealer.EmailAddress !== ''"
        >
          <i class="far fa-envelope"></i>
          <span>{{ activeDealer.EmailAddress }}</span>
          <i class="far fa-angle-right"></i>
        </a>
        <a
          :href="getWebsite(activeDealer.Website)"
          target="_blank"
          class="dm-resultoverlay__website"
          v-if="activeDealer.Website && activeDealer.Website !== ''"
        >
          <i class="far fa-globe"></i>
          <span>{{ translations.VisitWebsite }}</span>
          <i class="far fa-angle-right"></i>
        </a>
        <a
          :href="
            'https://www.google.com/maps/dir//' +
            activeDealer.Address.replace(' ', '+') +
            '+' +
            activeDealer.Postalcode.replace(' ', '+') +
            '+' +
            activeDealer.City.replace(' ', '+') +
            '/@' +
            activeDealer.Position.Lat +
            ',' +
            activeDealer.Position.Lng
          "
          target="_blank"
          class="dm-resultoverlay__route"
        >
          <i class="far fa-route"></i>
          <span>{{ translations.RoutePlanner }}</span>
          <i class="far fa-angle-right"></i>
        </a>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ResultOverlay',
  data() {
    return {
      active: this.activeDealer,
    }
  },
  props: {
    activeDealer: Object,
    translations: Object,
  },
  methods: {
    clearActiveDealer() {
      this.active = null
      this.$emit('update:activeDealer', this.active)
    },
    getCategoryCodeName(dealer) {
      if (
        dealer &&
        dealer.Categories &&
        dealer.Categories.length > 0 &&
        dealer.Categories[0].CodeName
      ) {
        return dealer.Categories[0].CodeName
      } else {
        return ''
      }
    },
    getCategoryDisplayName(dealer) {
      if (
        dealer &&
        dealer.Categories &&
        dealer.Categories.length > 0 &&
        dealer.Categories[0].DisplayName
      ) {
        return dealer.Categories[0].DisplayName
      } else {
        return ''
      }
    },
    getWebsite(website) {
      var url = ''
      if (website) {
        if (website.startsWith('https://') || website.startsWith('http://')) {
          url = ''
        } else {
          url = 'http://' + website
        }
      } else {
        url = ''
      }
      return url
    },
  },
}
</script>

<style lang="scss">
.dm-resultoverlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #ffffff;
  z-index: 10;

  &__button {
    padding: 20px 30px;
    border-bottom: 1px solid #dddddd;

    &:hover,
    &:focus {
      background: #fbfbfb;
      cursor: pointer;
    }
  }

  &__body {
    padding: 20px 30px;
  }

  &__label {
    margin-bottom: 10px;
  }

  &__title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &__phone {
    display: block;
  }

  &__website {
    display: block;
  }

  &__route {
    display: block;
  }
}
</style>
